var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditssettingicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3C83F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1395 14.6507C29.0526 14.5631 28.9492 14.4935 28.8352 14.4462C28.7212 14.3989 28.5989 14.3747 28.4755 14.375H27.8125V12.8125C27.8122 12.5639 27.7134 12.3257 27.5376 12.1499C27.3618 11.9741 27.1236 11.8753 26.875 11.875H13.3839C12.6522 11.875 11.9505 12.1657 11.4331 12.6831C10.9157 13.2005 10.625 13.9022 10.625 14.6339V25.3661C10.625 26.0978 10.9157 26.7995 11.4331 27.3169C11.9505 27.8343 12.6522 28.125 13.3839 28.125H28.4386C28.6865 28.1245 28.9242 28.026 29.0999 27.8509C29.2755 27.6759 29.3748 27.4385 29.3761 27.1905L29.4129 15.3157C29.4137 15.1923 29.3899 15.0699 29.343 14.9558C29.2961 14.8416 29.2269 14.7379 29.1395 14.6507ZM28.1271 26.875H13.3839C12.9837 26.875 12.5999 26.716 12.3169 26.4331C12.034 26.1501 11.875 25.7663 11.875 25.3661V14.6339C11.875 14.2337 12.034 13.8499 12.3169 13.5669C12.5999 13.284 12.9837 13.125 13.3839 13.125H26.5625V14.375H13.4375V15.625H28.162L28.1271 26.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 20.3125H26.5625V21.5625H25.3125V20.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditssettingicon);
export default __webpack_public_path__ + "static/media/Credits setting icon.4029e7594768f46a76b74f9b024e9f38.svg";
export { ForwardRef as ReactComponent };